import React from 'react';
import * as RT from '../../../constants/Routing';
import { Link } from 'react-router-dom';

import UserCard from '../ProfileCard';
import LoadingGif from '../../../lib/images/loading.gif';
import CircleListItem from '../../Community/ListItem'
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'

export default class Component extends React.Component {

  componentWillMount = () => {
    const currentUserId = this.props.App.currentUser ? this.props.App.currentUser.id : ''
    this.props.getMyCircleList(currentUserId)
  }

  componentWillReceiveProps = (nextProps) => {
    if (!!nextProps.Community.destroyed) {
      const currentUserId = this.props.App.currentUser.id
      this.props.getMyCircleList(currentUserId)
      this.props.communityDestroyFlagRemoveInMyPage()
    }
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname
    const currentUsersCircle = this.props.UserCircle.ownList

    let body
    if (this.props.UserCircle.listLoading) {
      body = (
        <img src={LoadingGif} alt='' className='loading-img' />
      )
    } else {
      if (currentUsersCircle.length > 0) {
        body = currentUsersCircle.map((circle) => {
          return (
            <CircleListItem key={circle.id} circle={circle} communityDestroy={this.props.communityDestroyInMyPage} currentUser={currentUser} />
          )
        })

      } else {
        body = (
          <div>
            <p>まだサークルを作成していません。<br />サークルを立ち上げてみましょう♪</p>
            <Link to={RT.COMMUNITY_NEW_PATH} className='btn btn-submit'>
              <i className="material-icons">add</i>
              新しいサークルを作る
            </Link>
          </div>
        )
      }
    }

    const metaInfo = (
      <Helmet>
        <title>マイページ | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)のマイページです。ここのページでは個人プロフィールの内容の確認、編集や、自分が立ち上げたサークルの編集・退会、自分が参加しているサークルの退会、新しいサークルの立ち上げができるページです。' />
      </Helmet>
    )


    return (
      <div className='container'>
        <UserCard user={currentUser} currentPath={currentPath}/>
        {metaInfo}
        {body}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/MyPage/MyPage.jsx